/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface WalletOperationFilter
 */
export interface WalletOperationFilter {
    /**
     * 
     * @type {string}
     * @memberof WalletOperationFilter
     */
    transactionType?: WalletOperationFilterTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WalletOperationFilter
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof WalletOperationFilter
     */
    clientEmail?: string;
    /**
     * 
     * @type {Date}
     * @memberof WalletOperationFilter
     */
    fromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WalletOperationFilter
     */
    toDate?: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum WalletOperationFilterTransactionTypeEnum {
    DEBIT = 'DEBIT',
    CREDITE = 'CREDITE'
}

